<template>
  <div class="animated fadeIn loading-overlay position-absolute w-100 h-100">
    <div class="bg-white w-100 h-100" />
    <breeding-rhombus-spinner
      :animation-duration="2000"
      :size="65"
      color="#2f353a"
      class="position-absolute"
    />
  </div>
</template>

<script>
import BreedingRhombusSpinner from "epic-spinners/src/components/lib/BreedingRhombusSpinner";

export default {
  components: { BreedingRhombusSpinner },
  name: "LoadingOverlay",
};
</script>
